import { render, staticRenderFns } from "./BuddycomCallTalkRecordList.vue?vue&type=template&id=47f6101a&scoped=true"
import script from "./BuddycomCallTalkRecordList.vue?vue&type=script&lang=js"
export * from "./BuddycomCallTalkRecordList.vue?vue&type=script&lang=js"
import style0 from "./BuddycomCallTalkRecordList.vue?vue&type=style&index=0&id=47f6101a&prod&lang=css"
import style1 from "./BuddycomCallTalkRecordList.vue?vue&type=style&index=1&id=47f6101a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f6101a",
  null
  
)

export default component.exports